import { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Check, ArrowRight } from "lucide-react";

export default function DealsPage() {
  const [services, setServices] = useState(null);
  const { items, add } = useCart();

  useEffect(() => {
    api.get("/marketing-services").then((r) => setServices(r.data)).catch(() => setServices([]));
  }, []);

  const deals = (services || []).filter((s) => ["bundles", "deals"].includes(s.platform) || s.sale_price > 0);

  return (
    <div data-testid="deals-page" className="max-w-7xl mx-auto px-6 py-20">
      <p className="text-xs tracking-[0.4em] uppercase text-brand mb-4">Bundles & Packages</p>
      <h1 className="font-display text-6xl sm:text-7xl text-white mb-4">Deals</h1>
      <p className="text-sm md:text-base text-zinc-400 max-w-3xl leading-relaxed mb-14">
        Bundled campaigns and limited-time packages — more reach, one price.
      </p>
      {services === null ? (
        <p className="text-zinc-500">Loading…</p>
      ) : deals.length === 0 ? (
        <div className="border border-white/10 p-12 text-center">
          <p className="text-zinc-400">No active deals right now — check back soon or browse Marketing.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {deals.map((s) => {
            const inCart = items.some((i) => i.id === s.id);
            const isDeposit = s.checkout_type === "deposit_approval";
            return (
              <article key={s.id} data-testid={`deal-card-${s.id}`}
                className="relative border border-brand/40 bg-[#0A0A0A] p-8 flex flex-col hover:-translate-y-1 transition-transform">
                <span className="absolute -top-3 left-6 bg-brand text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1">
                  {s.platform === "bundles" ? "Bundle" : "Deal"}
                </span>
                <h2 className="font-display text-3xl text-white mt-2">{s.name}</h2>
                <p className="text-sm text-zinc-400 mt-3 leading-relaxed flex-1">{s.description}</p>
                <div className="flex items-end justify-between mt-8 gap-3">
                  <div>
                    {s.sale_price > 0 && <p className="text-sm text-zinc-500 line-through">{fmt(s.price)}</p>}
                    <p className="font-display text-4xl text-white">{fmt(s.sale_price > 0 ? s.sale_price : s.price)}</p>
                    {isDeposit && <p className="text-xs text-zinc-500 mt-1">{fmt(s.deposit_amount)} deposit today · balance after approval</p>}
                  </div>
                  <button data-testid={`add-deal-${s.id}`} onClick={() => add(s)} disabled={inCart}
                    className={`flex items-center gap-2 text-xs font-semibold tracking-widest uppercase px-5 py-3 transition-colors whitespace-nowrap ${
                      inCart ? "bg-white/10 text-zinc-400 cursor-default" : "bg-brand hover:bg-brand-hover text-white"
                    }`}>
                    {inCart ? <><Check className="w-3.5 h-3.5" /> In Cart</> : <>Start Campaign <ArrowRight className="w-3.5 h-3.5" /></>}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
